module.exports = __webpack_public_path__ + "img/1568929087.7315f896.jpg";